import React from "react";
import { motion } from "framer-motion";

const IMAGES = [
  {
    src: "/images/elena/elena-risk-evolve-podium.png",
    caption: "Keynote address, Risk Evolve — CeFPro Events",
    span: "lg:col-span-7 lg:row-span-2",
    height: "h-[420px] lg:h-[640px]",
  },
  {
    src: "/images/elena/elena-oprisk-europe.jpg",
    caption: "Speaking at OpRisk Europe",
    span: "lg:col-span-5",
    height: "h-[300px]",
  },
  {
    src: "/images/elena/elena-book.png",
    caption: "Published author of Operational Risk Management in Financial Services",
    span: "lg:col-span-5",
    height: "h-[320px]",
    position: "object-top",
  },
];

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-16 md:py-24 bg-[#F9F8F6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7">
            <p className="font-sans-body text-xs tracking-widest-2 uppercase text-[#3E7373] mb-6 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-[#3E7373]" />
              The work in context
            </p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#0D0D0D] font-medium">
              Where ideas
              <br />
              <span className="italic text-[#3E7373]">become practice.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 font-sans-body text-[#4A4A4A] text-base md:text-lg leading-relaxed self-end">
            Leading conversations that shape risk management — on stage, in the boardroom and in the field.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {IMAGES.map((img, idx) => (
            <motion.figure
              key={img.src}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.9, delay: idx * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`gallery-image-${idx}`}
              className={`relative overflow-hidden ${img.span}`}
            >
              <img
                src={img.src}
                alt={img.caption}
                loading="lazy"
                decoding="async"
                width="800"
                height="640"
                sizes="(max-width: 1024px) 100vw, 33vw"
                className={`w-full ${img.height} object-cover ${img.position || "object-center"} hover:scale-[1.02] transition-transform duration-[1200ms] ease-out`}
              />
              <figcaption className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/55 to-transparent px-6 py-5">
                <p className="font-sans-body text-[11px] tracking-widest-2 uppercase text-white">
                  {img.caption}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
